// SlideTransition.js

import React, { useEffect, useRef } from 'react';
import { Animated } from 'react-native';

const SlideTransition = ({ duration = 300, from = 500, children, style={} }) => {
  const slideAnim = useRef(new Animated.Value(from)).current;

  useEffect(() => {
    Animated.spring(slideAnim, {
      toValue: 0,
      duration: duration,
      useNativeDriver: true,
      tension: 65,
      friction: 11,
    }).start();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Animated.View style={{ transform: [{ translateY: slideAnim }], ...style}}>
      {children}
    </Animated.View>
  );
};

export default SlideTransition;
